import React, { useContext } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Button } from "@cmsgov/ds-medicare-gov";
import { AppStore } from "../../app/store";
import { PlanDetailList, ScrollTable } from "../../components";
import { useTranslate, CONSTANTS, sendTealiumEvent } from "../../helpers";
import { displayDrug, displayPackage } from "../../helpers/prescriptionHelpers";
import routes from "../../app/routes";
import { PlanDetailsSection } from "../../@types";

const MyDrugs: React.FunctionComponent<RouteComponentProps> = ({ history }) => {
  const {
    state: { prescriptions },
  } = useContext(AppStore.AppContext);
  const t = useTranslate();

  const goToViewPrescriptions = (): void => {
    sendTealiumEvent("Plan Details", "Edit/Remove drugs");
    history.push(routes.prescriptionsList);
  };

  if (prescriptions.length > 0) {
    return (
      <PlanDetailList
        id={PlanDetailsSection.MY_DRUG_LIST}
        title={t("plan_terms.my_drug_list")}
      >
        <div className="DrugCostsTables__tableContainer">
          <ScrollTable className="PlanDetailTable">
            <thead>
              <tr>
                <th scope="col">{t("plan_terms.drug_list.selected_drugs")}</th>
                <th scope="col">{t("prescription.package")}</th>
                <th scope="col">{t("prescription.quantity")}</th>
                <th scope="col">{t("prescription.frequency")}</th>
                <th scope="col">
                  {t("plan_terms.drug_list.brand_or_generic")}
                </th>
              </tr>
            </thead>
            <tbody>
              {prescriptions.map(prescription => {
                return (
                  <tr key={prescription.ndc}>
                    <td>{displayDrug(t, prescription)}</td>
                    <td>
                      {prescription.use_package_quantity &&
                        displayPackage(t, prescription)}
                    </td>
                    <td>{prescription.quantity}</td>
                    <td>
                      {t(
                        CONSTANTS.prescriptionFrequencyLabels[
                          prescription.frequency
                        ]
                      )}
                    </td>
                    <td>
                      {prescription.is_generic
                        ? t("plan_terms.drug_list.generic")
                        : t("plan_terms.drug_list.brand")}
                    </td>
                  </tr>
                );
              })}
            </tbody>

            <tfoot className="drug-list__footer">
              <tr>
                <td colSpan={5}>
                  <Button
                    variation="transparent"
                    onClick={goToViewPrescriptions}
                    className="ds-c-button--primary plan-details--btn ds-u-sm-text-align--left ds-u-md-text-align--right ds-u-sm-padding-left--0 ds-u-lg-padding-right--0"
                  >
                    {t("plan_terms.drug_list.edit_remove_drugs")}
                  </Button>
                </td>
              </tr>
            </tfoot>
          </ScrollTable>
        </div>
      </PlanDetailList>
    );
  }
  return null;
};

export default withRouter(MyDrugs);
